import React from 'react';
import { ArrowRight } from 'lucide-react';
export function ActivityFeed() {
  const activities = [{
    id: 1,
    user: 'Lucia',
    initials: 'LR',
    action: 'ha completato',
    target: 'Via Roma 4',
    time: '10:32'
  }, {
    id: 2,
    user: 'Marco',
    initials: 'MV',
    action: 'ha accettato',
    target: 'Pacchetto Testaccio',
    time: '09:15'
  }, {
    id: 3,
    user: 'Giulia',
    initials: 'GB',
    action: 'ha iniziato',
    target: 'Zona Prati',
    time: '08:45'
  }, {
    id: 4,
    user: 'Sistema',
    initials: 'AI',
    action: 'ha ottimizzato',
    target: '3 nuovi percorsi',
    time: '08:00'
  }, {
    id: 5,
    user: 'Roberto',
    initials: 'RM',
    action: 'ha segnalato',
    target: 'Ritardo previsto',
    time: 'Ieri'
  }];
  return <div className="bg-white rounded-2xl flex flex-col h-full" data-id="element-37">
      <div className="px-6 py-5" data-id="element-38">
        <h3 className="font-semibold text-navy text-sm" data-id="element-39">Attività Team</h3>
      </div>

      <div className="px-6 pb-2 space-y-5 overflow-y-auto flex-1" data-id="element-40">
        {activities.map(activity => <div key={activity.id} className="flex gap-3 items-start" data-id="element-41">
            <div className="w-8 h-8 rounded-full flex-shrink-0 flex items-center justify-center text-[10px] font-bold bg-gray-100 text-gray-500" data-id="element-42">
              {activity.initials}
            </div>
            <div className="flex-1 min-w-0" data-id="element-43">
              <p className="text-sm text-gray-600 leading-snug" data-id="element-44">
                <span className="font-semibold text-navy" data-id="element-45">{activity.user}</span>{' '}
                {activity.action}{' '}
                <span className="font-medium text-navy" data-id="element-46">{activity.target}</span>
              </p>
              <p className="text-xs text-gray-300 mt-1" data-id="element-47">{activity.time}</p>
            </div>
          </div>)}
      </div>

      <div className="px-6 py-4" data-id="element-48">
        <button className="w-full text-xs font-medium text-gray-400 hover:text-navy flex items-center justify-center gap-1 py-2 rounded-lg transition-colors" data-id="element-49">
          Vedi Tutto <ArrowRight size={12} data-id="element-50" />
        </button>
      </div>
    </div>;
}